var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.facts.length)?_c('ul',{staticClass:"an-facts"},_vm._l((_vm.facts),function(fact,i){return _c('li',{key:i,staticClass:"an-facts__item",class:'an-facts__item--' + (fact.tone || 'neutral')},[_c('i',{staticClass:"fa an-facts__icon",class:_vm.icon(fact.tone)}),_c('span',[_vm._v(_vm._s(fact.text))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }